export const CODE_TABS = [
  {
    id: "python", label: "Python", file: "infrastructure.py", lang: "py",
    code: `# ECOREXS — Infrastructure Preview
# Illustrative example only

class ManagedInfrastructure:
    def __init__(self, client):
        self.client = client
        self.services = []

    def register_service(self, service):
        self.services.append(service)

    def system_status(self):
        return {
            "environment": "managed",
            "service_count": len(self.services),
            "monitoring": "configured"
        }`,
    output: [
      "$ python infrastructure.py",
      "› environment initialized  (managed)",
      "› service registered       website-environment",
      "› service registered       support-workflow",
      "› status                   service_count: 2",
    ],
  },
  {
    id: "javascript", label: "JavaScript", file: "architecture.js", lang: "js",
    code: `// ECOREXS — Service Architecture
// Illustrative example only

const infrastructure = {
  services: [],
  integrations: [],
  environment: "managed"
};

function connectService(service) {
  infrastructure.services.push(service);

  return {
    connected: true,
    name: service.name
  };
}`,
    output: [
      "$ node architecture.js",
      "› environment              managed",
      "› connectService()         business-website",
      "› connected                true",
      "› services                 1 active",
    ],
  },
  {
    id: "api", label: "API", file: "request.http", lang: "http",
    code: `# ECOREXS — Service Request (fictional)
# Illustrative example only

POST /v1/example/services
Content-Type: application/json

{
  "service": "managed-website",
  "billing_cycle": "monthly",
  "support": "included"
}

# Response — 201 Created
{
  "id": "svc_example_001",
  "status": "configuring",
  "next_step": "connect"
}`,
    output: [
      "$ send request.http",
      "› request                  POST /v1/example/services",
      "› response                 201 Created",
      "› status                   configuring",
      "› next_step                connect",
    ],
  },
  {
    id: "json", label: "JSON", file: "client-service.json", lang: "json",
    code: `{
  "_note": "Illustrative configuration only",
  "client": "Example Company",
  "services": [
    {
      "name": "Digital Infrastructure",
      "billing": "annual",
      "status": "managed"
    },
    {
      "name": "Technical Support",
      "billing": "monthly",
      "status": "active"
    }
  ],
  "integrations": ["payments", "email"],
  "environment": "managed"
}`,
    output: [
      "$ validate client-service.json",
      "› schema                   valid",
      "› services                 2 configured",
      "› integrations             payments, email",
      "› environment              managed",
    ],
  },
];

export const STEPS = ["Initialize", "Configure", "Connect", "Monitor", "Ready"];

const KW = {
  py: "class|def|return|self|import|from|for|in|if|else|None|True|False|len",
  js: "const|let|function|return|true|false|new|if|else|null",
  http: "POST|GET|PUT|DELETE|Content-Type",
  json: "true|false|null",
};

export function tokenize(line, lang) {
  const re = new RegExp(
    `(?<com>(?:#|//).*$)|(?<str>"[^"]*"|'[^']*')|(?<num>\\b\\d+\\b)|(?<kw>\\b(?:${KW[lang]})\\b)|(?<fn>\\b[A-Za-z_]\\w*(?=\\())|(?<txt>[\\s\\S])`,
    "g"
  );
  if (lang === "json" || lang === "http") {
    if (/^\s*#/.test(line)) return [{ t: "com", v: line }];
  }
  const out = [];
  let m;
  while ((m = re.exec(line))) {
    const g = m.groups;
    const t = g.com ? "com" : g.str ? (lang === "json" && /^\s*:/.test(line.slice(m.index + m[0].length)) ? "key" : "str")
      : g.num ? "num" : g.kw ? "kw" : g.fn ? "fn" : "txt";
    if (lang === "json" && g.com) { out.push({ t: "txt", v: m[0] }); continue; }
    const last = out[out.length - 1];
    if (t === "txt" && last && last.t === "txt") last.v += m[0];
    else out.push({ t, v: m[0] });
  }
  return out;
}
